export enum ApiVersion {
	V1 = "v1",
	V2 = "v2",
}
